<template>
	<v-card outlined>
		<v-toolbar
    		dense
    		height = "25"
    		class  = "secondary"
    	>
    		<v-toolbar-title 
    			class = "body-2 white--text"
    		>
    			{{ $ml.get('registered_devices') }}
    		</v-toolbar-title>
    	</v-toolbar>
		
		<v-divider></v-divider>

		<!-- show-select -->
		   	<!-- @input 				 = " v => render_selecteds(v, 'all')"		
		   	@item-selected 	   	 = " v => render_selecteds(v, 'select')" -->						    
		<v-data-table
			dense
		    fixed-body
		    fixed-header
			class 	 			 = "elevation-5"
			:items 	 			 = "render_list"
		    v-model 			 = "info_devices"
		    :height 			 = "layout_height + 'px'"
		   	:loading 			 = "loading"
			:headers 			 = "header_table"		   
			:options.sync 		 = "options"
		   	:loading-text 		 = "$ml.get('loading')"							   
		   	:server-items-length = "total"					
		   	:footer-props 		 = "{
		   		showFirstLastPage 	: true,
		   		itemsPerPageOptions : [total], // 15, 30
		   		showCurrentPage 	: true,
		   		itemsPerPageText 	: ''
		   	}"

		>
		<!-- Loading... Please wait -->
		    <!-- rowsPerPageText: [30] -->
		    <template v-slot:header.select = "{ header }">
		    	<v-checkbox
			      	hide-details
			      	v-model = "checkbox_all"		
			      	class   = "pa-0 ma-0 mt-1"
			     	@click  = "render_selecteds(info_devices,'all')"	    
		    		v-show 	= "show.edit_device"
			    ></v-checkbox>
		    </template>
		    <template v-slot:item.select = "{ item }">
		    	<v-checkbox
			      	hide-details
			      	v-model = "item.state"		
			      	class   = "pa-0 ma-0 mt-1"
			     	@click  = "render_selecteds(item ,'select')"	 
		    		v-show 	= "show.edit_device"
			    ></v-checkbox>
		    </template>
			<template v-slot:item.actions = "{ item }" >

				<v-btn
					x-small
					v-for   = "(item_btn, idx_btn) of btn_actions"
					:color  = "item_btn.color"
					@click  = "actions(item_btn.action, item)" 
					class   = "ml-1"
					:key 	= "idx_btn"
		    		v-show 	= "show.edit_device"
				>					
					<v-icon
						x-small
						color  = "white"
						v-text = "item_btn.icon"
					></v-icon>
				</v-btn>			
				
			</template>

			<template v-slot:top >
				 <v-text-field 
		        	dense			        	
		        	outlined
		        	hide-details
		        	v-model 	 = "search" 
		        	label		 = "Search" 
		        	class		 = "mx-4 pt-1" 
		        	append-icon  = "mdi-magnify" 
		        ></v-text-field>
		        	<!-- @click 		 = "keyboard_is_active()" -->
		        	<!-- @keyup.enter = "get_search(selected_tags)" -->
		        	<!-- @input 		 = "v => { search_tag = v.toUpperCase(); filter_search(v.toLowerCase()) }" -->
			</template>

			<template v-slot:item.state = "{ item }">
				<v-chip 
					small
					:color = " item.state ? 'success' : 'secondary'"
				>
					{{ ` ${item.state ? $ml.get('active') : $ml.get('inactive')}` }}
				</v-chip>
			</template>
			<template v-slot:item.device_status = "{ item }">
				<v-tooltip top>					
					<template v-slot:activator = "{on , attrs}">
						<v-icon small :color="item.device_status.color" v-bind="attrs" v-on="on">{{item.device_status.icon}} </v-icon>
						<span> {{$ml.get(item.device_status.text)}}</span>
					</template>
					<span> {{$ml.get(item.device_status.code)}}</span>
				</v-tooltip>
			</template>
		</v-data-table>
			
			<template
				v-for 	= "(item_dialog, idx_dialog) of info_dialogs"
			>
				<v-dialog 
					v-model = "info_dialog[item_dialog.key]" 
					width 	= "800"
					:key	= "idx_dialog"
				>
					<component
						:is 	 			= "item_dialog.key"
						:info_to_component 	= "info_selected"
						:is_to_clear 		= "true"
						@action_component 	= "receive_component($event, item_dialog.key)" 
						@close 				= "actions('close_modal', item_dialog.key)"
					></component>
				</v-dialog>
			</template>

	</v-card>
</template>
<script>
	import alarm_roi 	from '@/components/alarms/alarm_roi.vue'
	import schedule 	from '@/components/alarms/schedule.vue'
	export default{
		name  : 'Registered_devices',
		props : [ 'info_to_component' ],
		components: {
			alarm_roi,
			schedule
		},
		data  : (vm) => ({
			info_devices  : [],
			header_table  : [
				{
					text : '',
					value : 'select',
					sortable : false,
				},
				{
					text : vm.$ml.get('device_status'),
					value : 'device_status',
				},
				{	
					text  : vm.$ml.get('name'),
					value : 'name'
				},
				{
					text  : vm.$ml.get('type'),
					value : 'type',
				},
				{
					text  : vm.$ml.get('uuid'),
					value : 'deviceId', 
				},
				{
					text  : vm.$ml.get('status'),
					value : 'state', 
				},
				{
					text  : vm.$ml.get('actions'),
					value : 'actions'
				}
			],
			list 		  : [],
			total 		  : 0,
			options  	  : { itemsPerPage : 30 },
			layout_height : 300,
			search  	  : '',
			info_selected : null,
			dialog 		  : false,
			is_select     : false,
			btn_actions   : [
				{
					key  	: 'select_roi',
					type 	: 'btn',
					action 	: 'select_roi',
					color 	: 'primary',
					icon 	: 'mdi-vector-square'
				},
				{
					key  	: 'schedule',
					type 	: 'btn',
					action 	: 'select_schedule',
					color 	: 'blue darken-2',
					icon 	: 'mdi-calendar-clock'
				}
			],			
			info_dialogs 	: [
				{
					key 			: 'alarm_roi',
					dialog  		: 'dialog',
					type 			: 'component',
					info_component 	: 'info_selected',							
				},
				{
					key 			: 'schedule',
					dialog  		: '',
					type 			: 'component',
					info_component 	: 'info_selected'					
				}
			],
			info_dialog : {
				alarm_roi : false,
				schedule  : false,
			},
			loading 		: false,
			id_notification : 'Registered_devices',
			checkbox_all 	: true,
			info 			: null, 
			clear_info_comp : false,
			show 			: {
				edit_device : true,
			},
			bus 			: {},

		}), 
		watch : {

			/*dialog : function(val){
				console.log("DIALOG ", val)
				

			}, // dialog*/
			info_dialog : {
				handler(val){					
					if(val && (!val.schedule && !val.alarm_roi)){
						this.actions('close_modal')
					} // dialog
				}, deep : true
			}, // info dialog

			info_to_component: function(val){
				if (val) {
					this.render_info(val);
				}
			},

		}, // watch

		created(){			
			this.busDeviceStatusTechnical();
			if (this.info_to_component) {
				this.render_info(this.info_to_component);
			}			
			if (!this.$store.getters["auth/permission"](this.$route.name || "smart_event", "can_edit", "smart_event")) {
				this.show.edit_device = false;
			}
		}, // created

		methods : {

			actions(act, item, opt){
				// console.log("ACTIONS", act, item)
				if (act == 'select_roi') {
					this.info_selected 			= item;
					this.dialog 				= true;
					this.info_dialog.alarm_roi 	= true;

				}
				if (act == 'select_schedule') {
					this.info_selected 			= item;
					this.dialog 				= true;	
					this.info_dialog.schedule 	= true;
				}
				if (act == 'close_modal') {

					// this.dialog = false;
					if (this.info_selected && this.info_selected.deviceId) {
						this.$EventBus.$emit("close_stream", this.info_selected.deviceId);
					}
					this.info_selected 			= null;
					this.info_dialog.schedule   = false;
					this.info_dialog.alarm_roi  = false;
					/*this.clear_info_comp 		= true;
					
					const timer = setTimeout((vm)=>{
						vm.clear_info_comp = false;
						clearTimeout(timer);
					},20)*/
				}
			}, // actions

			receive_component(item1, component){
				if (item1) {
					console.log("receive_component : ", item1,  component)

					let { act, item } = item1; 
					if (act == 'render_selecteds') {
						this.render_selecteds( { 
							item : { item } ,
						}, 'update_item' );
					}
					if (act == 'render_selecteds_schedule') {
						this.render_selecteds( { 
							item : { item } ,
						}, 'update_schedule' );
					}
					if (component) {
						console.log("Close dialog : ", component)
						// this.dialog 				= false;
						this.info_dialog[component] = false;
						this.info_selected 			= null;
					}
				}
			}, // receive component

			get_local(){
				/*if (localStorage.getItem('list_devices')) {
					this.list = JSON.parse(localStorage.getItem('list_devices'));
					if (this.list && this.list.length > 0) {
						this.total = this.list.length;
					}

				}*/
			}, // get local

			render_info(item){
				if (item) {
					let temp_devices 	  = [],
						temp_list_devices = [],
						list_selecteds 	  = [];
					
					// let check_device = [];

					let points_temp = [
						{
						point1:[
						"0.0102",
						"0.0160"
						],
						point2:[
							"0.9918",
							"0.0160"
						],
						point3:[
							"0.9918",
							"0.9840"
						],
						point4:[
							"0.0102",
							"0.9840"
						]
						/*height : 0.9920,
						left   : 0.0051,
						top    : 0.0080,
						width  : 0.9949,*/

					}
					];	

					if (item.default && item.default.id) {
						this.info = item.default;
					}
					if (item.default && item.default.devices && item.default.devices.length > 0) {
						temp_devices 		= item.default.devices;
						// temp_list_devices 	= temp_devices;
					}else
						if (this.list && this.list.length > 0 /*&& temp_devices && this.list.length != temp_devices.length*/) {

						temp_list_devices = this.list;
						// temp_devices.forEach( (dev_list) => {
						// 	if (dev_list.deviceId ) {}
						// })

					}
					// temp_devices = this.list;
					
					/*console.log(item, 
						" DEVICES : " , temp_devices,
						" LIST DEVICES : " , temp_list_devices,
						)*/

					const temp_devices_format = this.$Format.format_devices_points([],  { 
						alarmId : this.info && this.info.id ?  this.info.id : null 
					});
					
					temp_devices.forEach( (dev) => {
						if (!dev.name) {
							// console.log("CHECK NAME ")
							const idx = temp_devices_format.findIndex(x => x && x.deviceId == dev.deviceId)
							if (idx >= 0) {
								dev.name = temp_devices_format[idx].name;
								dev.type = temp_devices_format[idx].type;

							}							
						}
						if (dev.state) {
							list_selecteds.push(dev);
						}
						dev.device_status = {
							color : "primary",
							icon : "mdi-cctv-off",
							text : "device_disconnected",
							code : "AG_BK_RTSP_00-1",
						};		

						// if (dev.deviceId) {
						// 	const find = temp_devices.some( (arr_dev) => {
						// 		if (arr_dev.deviceId == dev.deviceId) {
						// 			dev.points = arr_dev.points;
						// 			dev.state  = arr_dev.state ? true : false;
						// 			dev.type   = dev.type ? dev.type : 'IP CAM'; 
						// 			console.log("ADD SELECTS")

						// 			return true
						// 		}
						// 	})

						// 	if (!find) {
						// 		dev.points = JSON.stringify(points_temp);
						// 		dev.state = false;
						// 	}
						// }
					}); // forEach

					if (list_selecteds && temp_devices  && temp_devices.length > 0 && list_selecteds.length == temp_devices.length) {
						this.checkbox_all = true;
					}else{
						this.checkbox_all = false;
					}
					
					// console.log("temp_devices", temp_devices, temp_devices_format)
					if (temp_devices && temp_devices.length > 0) {
						this.list 			= temp_devices; 
						this.total 			= temp_devices.length === 1 ? 1 : temp_devices.length;

					}else if (temp_devices_format && temp_devices_format.length > 0) {						
						temp_devices_format.forEach(dev => {
							if (dev) {
								dev.state = false
							}
						})

						this.list 			= temp_devices_format; 
						this.total 			= temp_devices_format.length === 1 ? 1 : temp_devices_format.length;
					}
					this.info_devices 	= list_selecteds;
					// console.log(this.list , this.info, " ********************************** render info devices", temp_devices, temp_devices_format)

					this.$Helper.set_local('device_alarm', temp_devices);
					this.$EventBus.$emit("getListTechnicals",true);

						// this.total 		 = this.list.length;
				}
			}, // render info
			
			async render_selecteds(item, opt){
				// console.log("render SELECTS : ", item , opt, this.is_select)
				let vm = this;
				// if ( item ) {

					let list_temp = this.list,
						is_active = false;
					
					let alarm_id = this.info && this.info.id ? this.info.id : null;
					
					if (opt == 'all' /*&& !this.is_select*/) {
						// if (item && item.length > 0) {
						/*if (this.checkbox_all){
							this.checkbox_all = false;
							is_active = false

						}else{
							this.checkbox_all = true
							is_active = true;

						}*/
						is_active = this.checkbox_all;
						// }


						for(let dev  of list_temp) {
							if (dev.deviceId) {
								dev.state = is_active;
							}

							if (dev.id || dev.alarmId) {
								await vm.update_detail_device(dev);
							}else{
								if (alarm_id) {
									dev.alarmId = alarm_id;
									await vm.update_detail_device(dev);	
								}
							}
						}
						
					}/*else{
						this.is_select = false;
					}*/
					if (opt == 'select' || opt == 'update_item' || opt == 'update_schedule') {
						// this.is_select = true;
						if (list_temp && list_temp.length > 0) {

							// is_active = item.state == true ? false :   true;
							const find = list_temp.some( (ar_dev, idx_dev) => {
								if (item && ar_dev.deviceId == item.deviceId) {
									if (opt == 'select') {										
										// list_temp[idx_dev].state = !list_temp[idx_dev].state; //is_active	
										console.log("create device : ", list_temp[idx_dev], alarm_id)
										if (list_temp[idx_dev].id || list_temp[idx_dev].alarmId) {
											vm.update_detail_device(list_temp[idx_dev]);
										}else{
											if (alarm_id) {
												console.log("create device 1")
												list_temp[idx_dev].alarmId = alarm_id;
												vm.update_detail_device(list_temp[idx_dev]);	
											}
										}
										
										// console.log(list_temp[idx_dev], item.value, list_temp[idx_dev].state, ar_dev, is_active,item.item,  "**************************************** SELECTS 0")
									}
									if (opt == 'update_item') {
										list_temp[idx_dev].points = item.item.points;
									}
									if (opt == 'update_schedule') {
										list_temp[idx_dev].schedule = item.item.schedule;
									}
									
									return true;
								}
							});  // find device
						}
						console.log(list_temp , "**************************************** SELECTS")
					}
					// update list 
					
					// this.list = list_temp;					
					this.$emit('info_component', {
						act 	: 'render_compt',
						opt 	: 'devices',
						value 	: list_temp,
					})
					this.$Helper.set_local('device_alarm', list_temp);
				// }
			}, // render selecteds

			update_detail_device(item){
				if (item){
					console.log("update Devices detail : ", item )
					let opt = 'put';
					let ID  = ''
					let idx = this.list.findIndex( x => (x && x.deviceId == item.deviceId));
								
					ID  = item.id ?  '/'+ item.id : '';

										
					if (item.alarmId || item.id) {

						if (ID == '') {
							opt = 'post';							
						}

						const api = this.$URL + '/api/v1/alarm/device' + ID;
						// const api_roi = this.$URL + '/api/v1/alarm/roi/'
						this.$axios[opt](api, item).then( res => {
							console.log("** Updated / create ", this.id_notification, res);
							if (opt == 'post') {
								if (res.data) {
									let item_temp    	= res.data;
									item_temp.type   	= "IP CAM"; 
									item_temp.points 	= item.points;
									item_temp.schedule 	= item.schedule;
									item_temp.name 		= item.name;

									if (item_temp.detail_roi_device) {
										item_temp.points = item_temp.detail_roi_device;
										// this.$SmartEvent.set("list_points", item_temp, "create");
									}
									if (item_temp.detail_schedule_device && item_temp.detail_schedule_device.length > 0) {
										item_temp.schedule = item_temp.detail_schedule_device[0];
									}
									// item = item_temp;
									if (idx >= 0 ) {
										this.list.splice(idx,1,item_temp);
									}
									console.log(res.data, item_temp, idx);
									
								}else{
									console.log("No res to create roi")
								}
							}else{
								return true
							}
						}).catch( er => {
							console.log( "Error ", this.id_notification, er);
						})
					}else{
						console.log("ID not found to update ", this.id_notification );
					}
				}
			}, // update detail device
			renderDeviceStatus(item){
				// console.log("CHECK ITEM DEVICE STATUS ", item)				
				if (item) {
					if (item.code && (item.code.includes("BK_RTSP_") ||  item.code.includes("BK_RETRASMISSION_LOCAL"))) {						
						const idx = this.list.findIndex(x => x && x.deviceId == item.deviceId);
						if (idx >= 0) {
							let {code,icon_code,state,color_tag, icon, color} = item 
							let textState = "device_disconnected";
							if (state==0) {
								textState = "connected"; 
							}else if(state==1 || state==3){
								textState = "reconnecting"; 								
							}else if(state == -1){
								textState = "loading";
							}

							this.list[idx].device_status.code = code;
							this.list[idx].device_status.color = color || color_tag || "primary";
							this.list[idx].device_status.text = textState;
							this.list[idx].device_status.icon = icon || icon_code;

						}
					}
				}
			}, 

			busDeviceStatusTechnical(){
				this.$EventBus.$on('events_technical_mapview',  this.bus['events_technical_mapview'] = (action) => {
		      		if (action) {						      				      		
		      			this.renderDeviceStatus(action);
		      		}
		      	})
			},

		}, // methods

		computed : {

			render_list: function(){
				let list_filter  = [];
				let list_devices = this.list;
				let val  		 = this.search;
				let vm   		 = this;
				if (val){
					list_filter 	 = vm.list.filter( filter_dev => {
			    		return filter_dev && filter_dev.name.toLowerCase().indexOf(val.toLowerCase()) > -1
			    	}) 
					if (list_filter.length === 0 ) {						
						list_filter = vm.list.filter( dev1 => {
						return dev1 && dev1.deviceId.toLowerCase().indexOf(val.toLowerCase()) > -1;
						});
						
					}
				}else{
					list_filter = list_devices;
				}
				return list_filter;
			},

		}, // computed		
		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, "Registered_devices");
		},
	};
</script>